<template>
    <nav class="d-flex justify-content-between flex-column">
        <div class="container-fluid flex-grow-1">
            <ul>
                <li>
                    <router-link to="/me">My Profile</router-link>
                </li>
            </ul>
            <ul>
                <!-- <lh class="font-italic">Services for you</lh> -->
                <li>
                    <router-link to="/insurance">Insurance Highlights</router-link>
                    <ul>
                        <li>
                            <router-link :to="{name: 'TravelAssistance'}">Travel Assistance</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'MedicalExpenses'}">Medical Expenses</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'PersonalAccident'}">Personal Accident</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'ThirdPartyLiability'}">Third Party Liability</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'TravelInconveniences'}">Travel Inconveniences</router-link>
                        </li>
                        <li>
                            <router-link :to="{name: 'CoverStay'}">Cover Stay</router-link>
                        </li>
                    </ul>
                </li>
                <li>
                    <router-link to="/file-claim">File claim</router-link>
                    <ul>
                        <li><router-link to="/claim-documentation">Claim Documentation</router-link></li>
                    </ul>
                </li>
                <li>
                    <router-link to="/contact-us">Contact Us</router-link>
                </li>
                <li>
                    <a :href="`/public/docs/ins4models-terms_and_conditions_${new Date().getFullYear()}.pdf`" target="_blank" alt="Terms and Conditions">Policy Terms and Conditions</a>
                </li>
                <li>
                    <router-link to="/about-us">About Us</router-link>
                </li>
            </ul>
            <ul>                
                <li>
                    <router-link to="/elite/our-network">ELITE Agencies</router-link>
                </li>
            </ul>
            <ul>                
                <li>
                    <a @click="$emit('logout')">Logout</a>
                </li>
            </ul>
        </div>
        <div class="container-fluid">
            <NeedHelp/>
        </div>
    </nav>
</template>

<script>
import NeedHelp from '@/components/NeedHelp.vue'

export default {
    components: {
        NeedHelp
    },
    methods: {
        
    }
}
</script>